import ReactTooltip from "react-tooltip";
import { Helmet } from "react-helmet-async";
import { cdn } from "../../../../consts/cdn.js";
import { JwPlayer } from "../../../JwPlayer/JwPlayer.js";
import "../../../../App.css";
import "../../../_Shared/utility.css";
import "./WhyVnotes.css";
import { FRBanner } from "../../../Banner/Banner.js";
import { Button } from "../../../Button/Button.js";
import { TestimonalQuote } from "../../../TestimonalQuote/TestimonalQuote.js";

//Images
const BannerDesktop =
  cdn.images + "HealthcareProviders/Banner-Desktop-Compressed.jpg";
const BannerMobile = cdn.images + "HealthcareProviders/Banner-Mobile.jpg";
const Thumbnail1 = cdn.images + "HealthcareProviders/Thumbnail1-fr.jpg";
const Thumbnail2 = cdn.images + "HealthcareProviders/Thumbnail2.jpg";
const Image1 = cdn.images + "HealthcareProviders/Image1.jpg";
const Circle1 = cdn.images + "HealthcareProviders/Group 1591.svg";
const Circle2 = cdn.images + "HealthcareProviders/Group 1400.svg";
const email = cdn.images + "HealthcareProviders/Path 1563.svg";

function WhyVnotes() {
  return (
    <>
      <div className="hcphome">
        <Helmet>
          <title>
            vNOTES – Advanced Minimally Invasive Gynecologic Procedures
          </title>
          <link
            rel="canonical"
            href="https://www.vnotes.com/healthcareprofessionals"
          />
          <meta
            name="description"
            content="vNOTES (vaginal natural orifice transluminal endoscopic surgery) workshops provide a comprehensive understanding of procedural steps and instrumentation used…"
          />
        </Helmet>
        <FRBanner
          imgdesktop={BannerDesktop}
          imgmobile={BannerMobile}
          bold1="vNOTES"
          text1="La prochaine évolution en chirurgie"
          text2="gynécologique mini-invasive"
          color="#365B7E"
          openSans="true"
        />
        <div className="content">
          <div className="hcphome__extrapadding">
            <h1 className="header-primary header-primary--blue header-primary--comfortaa">
              POURQUOI LA CHIRURGIE{" "}
              <span
                style={{ textTransform: "lowercase", fontFamily: "Comfortaa" }}
              >
                v
              </span>
              NOTES ?
            </h1>
            <p className="paragraph">
              L'hystérectomie vaginale, lorsqu'elle est indiquée et réalisable,
              est l'approche recommandée par l'ACOG (American College of
              Obstetricians and Gynecologists), l'AAGL (American Association of
              Gynecologic Laparoscopists), l'ISGE (International Society for
              Gynecologic Endoscopy) et Cochrane.
              <sup
                className="ref__style"
                data-background-color="#FAFAFA"
                data-text-color="#707070"
                data-tip="Committee Opinion No 701: Choosing the Route of Hysterectomy for Benign Disease. <i>Obstet Gynecol</i>. 2017;129(6):e155-e159.<br/>doi:10.1097/AOG.0000000000002112<br/><br/>AAGL Advancing Minimally Invasive Gynecology Worldwide. AAGL position statement: route of hysterectomy to treat benign uterine disease. <i>J Minim Invasive Gynecol</i>. 2011;18(1):1-3.<br/>doi:10.1016/j.jmig.2010.10.001<br/><br/>
                                 Chrysostomou A, Djokovic D, Edridge W, van Herendael BJ. Evidence-based practical guidelines of the International Society for Gynecologic Endoscopy (ISGE) for vaginal hysterectomy. <i>Eur J Obstet Gynecol Reprod Biol.</i> 2020;252:118- 1 26.<br/>doi:10.1016/j.ejogrb.2020.06.027<br/><br/>                               
                                 Aarts JW, Nieboer TE, Johnson N, et al. Surgical approach to hysterectomy for benign gynaecological disease. <i>Cochrane Database Syst Rev.</i> 2015;2015(8):CD003677. Published 2015 Aug 12.<br/>doi:10.1002/14651858.CD003677.pub5"
                data-class="sup__style"
                data-arrow-color="transparent"
                data-html="true"
              >
                REF
              </sup>{" "}
              Malgré ces recommandations et les preuves cliniques à l'appui, le
              taux d'hystérectomies vaginales n'a cessé de diminuer. Le manque
              de visibilité et l'accès réduit à l'anatomie sont quelques-uns des
              défis qui contribuent à la diminution de l'approche vaginale.
              L'accès aux annexes peut être particulièrement difficile, avec des
              taux d'échec allant jusqu'à 36 % .
              <sup
                className="ref__style"
                data-background-color="#FAFAFA"
                data-text-color="#707070"
                data-tip="Robert M, Cenaiko D, Sepandj J, Iwanicki S. Success and Complications of Salpingectomy at the Time of Vaginal Hysterectomy. <i>J Minim Invasive Gynecol</i>. 2015;22(5):864-869.<br/>doi:10.1016/j.jmig.2015.04.012<br/><br/>Mothes AR, Schlachetzki A, Nicolaus K, et al. LAVH superior to TVH when concomitant salpingo-oophorectomy is intended in prolapse hysterectomy: a comparative cohort study. <i>Arch Gynecol Obstet</i>. 2018;298(6):1131-1137.<br/>doi:10.1007/s00404-018-4909-z"
                data-class="sup__style"
                data-arrow-color="transparent"
                data-html="true"
              >
                REF
              </sup>{" "}
              <br />
              <br />
              Le vNOTES (vaginal natural orifice transluminal endoscopic surgery
              - chirurgie vaginale endoscopique par voie naturelle) modernise la
              chirurgie vaginale. Les plateformes d'accès avancées permettent
              d'accéder à la cavité péritonéale par le vagin, combinant
              efficacement les avantages de la chirurgie laparoscopique et de la
              chirurgie vaginale traditionnelle.
            </p>
          </div>

          <div className="hcphome__testimonal-container">
            <div className="hcphome__testimonal-video">
              <JwPlayer
                file="https://ep-appliedmediaservice-ammedia-mediakind.westus2.streaming.mediakind.com/ee04b62a-2393-40bd-8eed-6bb897d7fa53/388371-FR-C vNOTES Hysterectomy .ism/manifest(format=m3u8-cmaf)"
                title="Hystérectomie vNOTES avec la plateforme d'accès transvaginal GelPOINT"
                image={Thumbnail1}
              ></JwPlayer>
              <div className="video-description">
                <p>
                  Hystérectomie vNOTES avec la plateforme d'accès transvaginal
                  GelPOINT
                  <sup>™</sup> V‑Path
                </p>
              </div>
            </div>

            <div className="hcphome__testimonal-video">
              <JwPlayer
                file="https://ep-appliedmediaservice-ammedia-mediakind.westus2.streaming.mediakind.com/66f2e943-684c-48c5-8deb-f20d4c8a9e79/Highlight_ vNOTES as Featured on.ism/manifest(format=m3u8-cmaf)"
                title="The Benefits of vNOTES as Featured on ACOG TV"
                image={Thumbnail2}
              ></JwPlayer>
              <div className="video-description">
                <p>
                  Les avantages du vNOTES présentés sur ACOG TV*
                  <br />
                  <small className="note">
                    * La vidéo étant en anglais, pour obtenir la traduction en
                    français, veuillez&nbsp;
                    <a
                      href="/fr/contactus"
                      aria-label="Contact us for French translation"
                    >
                      nous contacter
                    </a>
                    .
                  </small>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div style={{ background: "#fafafa", zIndex: "2" }}>
          <img
            src={Image1}
            className="hcphome__img--1"
            alt="img1"
            loading="lazy"
          />
        </div>

        <div className="hcphome__gray-container hcphome__gray-container--1">
          <img className="hcphome__circle-svg--1" src={Circle1} alt="circle" />
          <div className="content" style={{ marginTop: "0", paddingTop: "0" }}>
            <h1
              className="header-primary header-primary--blue header-primary--comfortaa"
              style={{ marginTop: "0", paddingTop: "0" }}
            >
              QUELS SONT LES <br className="br__desktop-only" />
              AVANTAGES DU{" "}
              <span
                style={{ textTransform: "lowercase", fontFamily: "Comfortaa" }}
              >
                v
              </span>
              NOTES ?
            </h1>
            <div className="hcphome__button-container">
              <div className="modal__btn-left-container btn-special">
                <Button
                  className="modal__btn--left "
                  route="/fr/hcptestimonials"
                  id="hcp-testimonials-button"
                >
                  Voir les témoignages des professionnels de santé
                </Button>
              </div>
              <div className="modal__btn-right-container btn-special">
                <Button
                  className="modal__btn--right"
                  route="/fr/patientstestimonials"
                  id="patient-testimonials-button"
                >
                  Voir les témoignages des patientes
                </Button>
              </div>
            </div>
          </div>
        </div>

        <div className="hcphome__section-container">
          <div className="hcphome__section hcphome__section--one">
            <h3 className="hcphome__section-header">
              Le vNOTES améliore la visualisation et l'accès par rapport à la
              chirurgie vaginale traditionnelle&nbsp;
              <sup
                className="ref__style"
                data-background-color="#FAFAFA"
                data-text-color="#707070"
                data-tip="Lee CL, Wu KY, Su H, Wu PJ, Han CM, Yen CF. Hysterectomy by transvaginal natural orifice transluminal endoscopic surgery (NOTES): a series of 137 patients. <i>J Minim Invasive Gynecol</i>. 2014;21(5):818-824.<br/>doi:10.1016/j.jmig.2014.03.011"
                data-class="sup__style"
                data-arrow-color="transparent"
                data-html="true"
              >
                REF
              </sup>
              &nbsp;:
            </h3>
            <ul className="hcp-li-bullets">
              <li className="paragraph">
                Identification plus facile des uretères&nbsp;
                <sup
                  className="ref__style"
                  data-background-color="#FAFAFA"
                  data-text-color="#707070"
                  data-tip="Lowenstein L, Baekelandt J, Paz Y, Lauterbach R, Matanes E. Transvaginal Natural Orifice Transluminal Endoscopic Hysterectomy and Apical Suspension of the Vaginal Cuff to the Uterosacral Ligament. <i>J Minim Invasive Gynecol</i>. 2019;26(6):1015.<br/>doi:10.1016/j.jmig.2019.04.007"
                  data-class="sup__style"
                  data-arrow-color="transparent"
                  data-html="true"
                >
                  REF
                </sup>
              </li>
              <li className="paragraph">
                Exploration abdominale plus complète
              </li>
              <li className="paragraph">
                Meilleure capacité à soutenir le plancher pelvien&nbsp;
                <sup
                  className="ref__style"
                  data-background-color="#FAFAFA"
                  data-text-color="#707070"
                  data-tip="Lowenstein L, Baekelandt J, Paz Y, Lauterbach R, Matanes E. Transvaginal Natural Orifice Transluminal Endoscopic Hysterectomy and Apical Suspension of the Vaginal Cuff to the Uterosacral Ligament. <i>J Minim Invasive Gynecol</i>. 2019;26(6):1015.<br/>doi:10.1016/j.jmig.2019.04.007"
                  data-class="sup__style"
                  data-arrow-color="transparent"
                  data-html="true"
                >
                  REF
                </sup>
              </li>
              <li className="paragraph">
                Meilleure capacité à retirer les annexes et les gros
                utérus&nbsp;
                <sup
                  className="ref__style"
                  data-background-color="#FAFAFA"
                  data-text-color="#707070"
                  data-tip="Baekelandt J, Cavens D. GelPOINT (Applied Medical) is a suitable port for transvaginal NOTES procedures. <i>J Gynecol Surg</i>. 2016;32(5):257-262.<br/>doi:10.1089/gyn.2016.0013"
                  data-class="sup__style"
                  data-arrow-color="transparent"
                  data-html="true"
                >
                  REF
                </sup>
              </li>
              <li className="paragraph">Facilité d'enseignement</li>
            </ul>
          </div>
          <div className="hcphome__section hcphome__section--two">
            <h3 className="hcphome__section-header">
              Le vNOTES a montré les avantages suivants par rapport à la
              chirurgie laparoscopique :
            </h3>
            <ul>
              <li className="paragraph">
                Moins de douleurs post-opératoires et d'analgésiques&nbsp;
                <sup
                  className="ref__style"
                  data-background-color="#FAFAFA"
                  data-text-color="#707070"
                  data-tip="Baekelandt JF, De Mulder PA, Le Roy I, et al. Hysterectomy by transvaginal natural orifice transluminal endoscopic surgery versus laparoscopy as a day-care procedure: a randomised controlled trial. <i>BJOG</i>. 2019;126(1):105-113.<br/>doi:10.1111/1471-0528.15504"
                  data-class="sup__style"
                  data-arrow-color="transparent"
                  data-html="true"
                >
                  REF
                </sup>
              </li>
              <li className="paragraph">
                Amélioration de l'ergonomie pour les chirurgiens&nbsp;
                <sup
                  className="ref__style"
                  data-background-color="#FAFAFA"
                  data-text-color="#707070"
                  data-tip="Burnett AF, Rojo MO. Vaginal natural orifice transluminal endoscopic surgery for gynecologic and gynecologic oncology procedures. <i>IntechOpen</i>. 2020;1(9)<br/>doi:10.5772/intechopen.96082"
                  data-class="sup__style"
                  data-arrow-color="transparent"
                  data-html="true"
                >
                  REF
                </sup>
              </li>
              <li className="paragraph">
                Meilleur résultat esthétique&nbsp;
                <sup
                  className="ref__style"
                  data-background-color="#FAFAFA"
                  data-text-color="#707070"
                  data-tip="Lowenstein L, Baekelandt J, Paz Y, Lauterbach R, Matanes E. Transvaginal Natural Orifice Transluminal Endoscopic Hysterectomy and Apical Suspension of the Vaginal Cuff to the Uterosacral Ligament. <i>J Minim Invasive Gynecol</i>. 2019;26(6):1015.<br/>doi:10.1016/j.jmig.2019.04.007"
                  data-class="sup__style"
                  data-arrow-color="transparent"
                  data-html="true"
                >
                  REF
                </sup>
              </li>
              <li className="paragraph">
                Récupération plus rapide&nbsp;
                <sup
                  className="ref__style"
                  data-background-color="#FAFAFA"
                  data-text-color="#707070"
                  data-tip="Baekelandt JF, De Mulder PA, Le Roy I, et al. Hysterectomy by transvaginal natural orifice transluminal endoscopic surgery versus laparoscopy as a day-care procedure: a randomised controlled trial. <i>BJOG</i>. 2019;126(1):105-113.<br/>doi:10.1111/1471-0528.15504"
                  data-class="sup__style"
                  data-arrow-color="transparent"
                  data-html="true"
                >
                  REF
                </sup>
              </li>
              <li className="paragraph">
                Moins d'infections post-opératoires&nbsp;
                <sup
                  className="ref__style"
                  data-background-color="#FAFAFA"
                  data-text-color="#707070"
                  data-tip="Housmans S, Noori N, Kapurubandara S, et al. Systematic Review and Meta-Analysis on Hysterectomy by Vaginal Natural Orifice Transluminal Endoscopic Surgery (vNOTES) Compared to Laparoscopic Hysterectomy for Benign Indications. <i>J Clin Med</i>. 2020;9(12):3959. Published 2020 Dec 7.<br/>doi:10.3390/jcm9123959"
                  data-class="sup__style"
                  data-arrow-color="transparent"
                  data-html="true"
                >
                  REF
                </sup>
              </li>
            </ul>
          </div>
        </div>

        <div className="content">
          <p className="paragraph">
            Le vNOTES peut ne pas convenir à toutes les patientes. Le vNOTES, à
            ce stade, est réalisé pour des indications gynécologiques bénignes.
            Il n’est pas recommandé de sélectionner des patientes avec un
            historique de chirurgie ou d’infection pelvienne.&nbsp;
            <sup
              className="ref__style"
              data-background-color="#FAFAFA"
              data-text-color="#707070"
              data-tip="Kapurubandara S, et al. Consensus on safe implementation of vaginal natural orifice transluminal endoscopic surgery (vNOTES).
                 <i>Eur J Obstet Gynecol Reprod Biol.</i> 2021;263:216-222. doi:10.1016/j.ejogrb.2021.06.019"
              data-class="sup__style"
              data-arrow-color="transparent"
              data-html="true"
            >
              REF
            </sup>{" "}
          </p>
        </div>

        <div className="hcphome__gray-container hcphome__gray-container--4">
          <div className="hcphome__extrapadding">
            <TestimonalQuote
              quote="Patients are very surprised at the rapidity of the recovery.  
              Most of the time, they are very, very happy after the experience. 
              They say, 'If I had known, I would have done it before!'"
              quote2={
                "« Les patientes sont très surprises de la rapidité du rétablissement. \n" +
                "La plupart du temps, elles sont très, très heureuses après cette intervention. \n" +
                "Elles disent \"Si j'avais su, je l'aurais fait avant !\" »"
              }
              name="Dr. Géraldine Giraudet"
              location="France"
            />
          </div>
        </div>

        <div className="content">
          <h1 className="header-primary header-primary--blue header-primary--comfortaa">
            COMMENT FAIRE EVOLUER MA
            <br className="br__desktop-only" /> PRATIQUE AVEC LE{" "}
            <span
              style={{ textTransform: "lowercase", fontFamily: "Comfortaa" }}
            >
              v
            </span>
            NOTES ?
          </h1>
          <p className="paragraph">
            Les formations vNOTES permettent une compréhension complète des
            étapes de l’intervention et de l’instrumentation utilisée dans le
            traitement des pathologies gynécologiques bénignes. La formation
            comprend les éléments suivants :
          </p>
          <ul className="hcp__paragraph-li">
            <li className="paragraph">
              Des exposés didactiques passant en revue les indications, la
              littérature clinique, l’anatomie et la mise en place des
              dispositifs
            </li>
            <li className="paragraph">
              Des travaux pratiques avec des modèles de tissus Simsei
              <sup>™</sup> réalistes pour simuler la technique vNOTES
            </li>
            <li className="paragraph">
              Des conseils et retours d’expériences de chirurgiens experts
            </li>
            <li className="paragraph">
              Une formation continue et du support une fois la formation
              complétée
            </li>
          </ul>
        </div>

        <div className="hcphome__gray-container hcphome__gray-container--2">
          <img className="hcphome__circle-svg--2" src={Circle2} alt="circle" />
          <div
            className="content hcphome__right-content"
            style={{ marginTop: 0, paddingTop: 0, width: "100%" }}
          >
            <h1
              className="header-primary header-primary--blue header-primary--comfortaa"
              style={{ margin: "0px" }}
            >
              FORMATIONS&nbsp;
              <span
                style={{ textTransform: "lowercase", fontFamily: "Comfortaa" }}
              >
                v
              </span>
              NOTES
            </h1>
            <p className="hcphome__subheader">
              Contactez-nous pour plus d'informations sur le vNOTES{" "}
              <br className="br__desktop-only" /> et sur la disponibilité des
              formations dans votre région.{" "}
            </p>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button route="/fr/contactus">Contactez-nous</Button>
            </div>
          </div>
        </div>

        <div className="hcphome__gray-container hcphome__gray-container--3">
          <div className="center">
            <div>
              <h1 className="header-primary header-primary--blue header-primary--comfortaa max-content">
                Contactez-nous
              </h1>
              <div className="hcphome__button-container hcphome__button-container--3">
                <a
                  href="mailto:vNOTES@appliedmedical.com"
                  className="eventstile__link"
                  target="_blank"
                  rel="noreferrer"
                >
                  <button className="hcphome__button btn">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        className="connectus__icon connectus__icon--twitter"
                        src={email}
                        alt=""
                        loading="lazy"
                      />
                      <span>Courriel</span>
                    </div>
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
        <ReactTooltip />
      </div>
    </>
  );
}

export default WhyVnotes;
